/**
 * Section heading with an optional subtitle line.
 *
 * Props:
 *   title    - main heading text
 *   subtitle - optional smaller text below the title
 */
export function SectionHeading({ title, subtitle }) {
  return (
    <div className="mb-5">
      <h2 className="text-xl font-semibold text-foreground font-display">
        {title}
      </h2>
      {subtitle && <p className="text-sm text-muted-foreground mt-0.5">{subtitle}</p>}
    </div>
  );
}
